
import { mapGetters, mapActions } from 'vuex'

export default {
  computed: {
    ...mapGetters('product-open', ['allCategorias', 'categoriaRelactedOrg']),
    isLoading() {
      return this.allCategorias.length === 0
    },

    categorys() {
      if (this.categoriaRelactedOrg.length === 0) {
        return this.allCategorias
      } else {
        return this.categoriaRelactedOrg
      }
    },
  },
  mounted() {
    const screenWidth = this.$vuetify.breakpoint.width < 1024
    if (screenWidth) {
      this.loadCategory()
    }
  },
  methods: {
    ...mapActions('product-open', [
      'verifyCookieCategoria',
      'fetchCategoriaOpen',
    ]),
    async loadCategory() {
      try {
        if (this.allCategorias.length === 0) {
          await this.fetchCategoriaOpen()
        }
        this.verifyCookieCategoria()
      } catch (error) {
        this.$toast.error('Error: ' + error)
      }
    },
  },
}
